export const SIZE_1X1 = '1x1';
export const SIZE_2X1 = '2x1';
export const SIZE_4X1 = '4x1';
export const SIZE_4X2 = '4x2';
